import { render, staticRenderFns } from "./RequestChanges.vue?vue&type=template&id=6e69e24c"
import script from "./RequestChanges.vue?vue&type=script&lang=js"
export * from "./RequestChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports